import React from 'react'

class SearchTutorsResult extends React.Component {

  onClick = () => {
    this.props.onClick(this.props.result)
  }

  render() {
    return (
      <li className="cursor-pointer rounded-[10px] border border-border bg-card px-4 py-3 hover:bg-muted/50" onClick={this.onClick}>
        {this.props.result.name} <span className="text-muted-foreground">- Tutor {this.props.result.id}</span>
      </li>
    )
  }
}

export default SearchTutorsResult
